import { createFileRoute } from "@tanstack/react-router";
import { ServiceDetail } from "@/components/site/ServiceDetail";
import hero from "@/assets/hero-clean-living-room.webp";

export const Route = createFileRoute("/services/domestic")({
  head: () => ({
    meta: [
      { title: "Domestic Cleaning in Tidworth, Andover & Salisbury | IZHUB" },
      { name: "description", content: "Regular domestic cleaning across Tidworth, Andover and Salisbury. Weekly or fortnightly home cleans by a trusted, vetted local cleaner. Get an instant quote." },
      { property: "og:title", content: "Domestic Cleaning | IZHUB Cleaning Services" },
      { property: "og:description", content: "Reliable weekly and fortnightly home cleaning across Salisbury Plain — kitchens, bathrooms, dusting, vacuuming and more." },
      { property: "og:url", content: "https://izhubcleaning.uk/services/domestic" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/services/domestic" }],
  }),
  component: DomesticPage,
});

function DomesticPage() {
  return (
    <ServiceDetail
      data={{
        title: "Domestic Cleaning",
        heroTitle: <>Domestic cleaning that keeps your home <span className="rainbow-text">consistently fresh</span>.</>,
        intro: "Regular, reliable home cleaning across Tidworth, Andover and Salisbury — weekly, fortnightly, or as often as you need.",
        image: hero,
        imageAlt: "A bright, freshly cleaned living room after a domestic clean",
        forWho: "Busy households, shared homes, working professionals, families.",
        quoteService: "regular",
        includes: [
          "Kitchens, bathrooms, living areas and bedrooms",
          "Dusting, vacuuming, mopping and surface cleans",
          "Weekly, fortnightly or one-off options",
          "The same regular cleaner, so standards stay consistent",
          "Flexible tasks each visit — tell us your priorities",
          "All products and equipment can be provided",
        ],
        paragraphs: [
          "Our domestic cleaning service is built around one simple idea: your home should feel clean every week, not just after a big effort. A regular cleaner visits on a schedule that suits you and follows your priorities — kitchens and bathrooms one week, a deeper dust the next.",
          "Every cleaner is vetted, insured and trained to the IZHUB standard. Wherever possible you keep the same cleaner each visit, so they learn your home and you always know who is coming through the door.",
          "We cover homes across Tidworth, Andover, Salisbury, Amesbury, Bulford, Larkhill and the surrounding villages. Get an instant price online in under a minute, or message us on WhatsApp to talk through what you need.",
        ],
      }}
    />
  );
}
